<template>
  <div class="preview_wrapper sign-in">
    <left-register-bar v-if="!isMobileDevice"></left-register-bar>
    <div class="registration">
      <div class="container no-gap">
        <div class="registration_form__wrapper">
          <div class="registration_form">

            <div v-if="isMobileDevice">
              <a class="return_link" href="https://croinc.ru/">
              <span class="return_link__icon">
                <i class="material-icons">chevron_left</i>
              </span>
                <small class="return_link__text">Вернутся на главную</small>
              </a>
            </div>

            <el-form :model="context" :rules="rules" ref="stepOne">

              <el-form-item>
                <div class="info_label  bottom_gap"> Выбирите тип</div>
                <div class="type_app">
                  <a class="type_app__link" href="https://lite.croinc.ru/admin/sign-up">Самозанятый </a>
                  <routerLink class="type_app__link active" to="/register">Компания</routerLink>
                </div>
              </el-form-item>

              <el-form-item label prop="companyName">

                <div class="info_label bottom_gap --none">Название компании</div>

                <div class="left-form_item-input">
                  <el-input placeholder="Название компании" v-model="context.companyName"></el-input>
                </div>


              </el-form-item>

              <el-form-item label prop="country">
                <div class="info_label  bottom_gap --none"> Страна</div>
                  <div class="left-form_item-input">
                    <el-select v-model="context.country" placeholder="Страна">
                      <el-option
                          v-for="country in countries"
                          :key="country.value"
                          :label="country.label"
                          :value="country.value">
                      </el-option>
                    </el-select>
                  </div>
              </el-form-item>

              <el-form-item label prop="timezone">
                <div class="info_label  bottom_gap --none"> Таймзона</div>
                    <el-select v-model="context.timezone" placeholder="Таймзона" filterable>
                      <el-option
                          v-for="i in timezones"
                          :key="i"
                          :label="i"
                          :value="i">
                      </el-option>
                    </el-select>
              </el-form-item>

              <el-form-item label prop="mail">
                <div class="info_label bottom_gap --none"> Электронная почта</div>
                  <div class="left-form_item-input">
                    <el-input placeholder="Электронная почта" v-model="context.mail" auto-complete="new-email"></el-input>
                  </div>
              </el-form-item>

              <el-form-item label prop="phone">
                <div class="info_label  bottom_gap --none"> Контактный телефон</div>
                <phoneInput class="el-input" id="phone"
                            v-model='context.phone'
                            :phone="context.phone"
                            @phoneChanged="phoneValChanged">
                </phoneInput>
              </el-form-item>

            </el-form>


            <div class="left-form-buttons">
              <div class="left-form-buttons_button w100 black" @click="submitForm('stepOne')">Далее</div>
<!--              <div class="left-form-buttons_button w100 white"><router-link to='/'>Отмена</router-link></div>-->
            </div>

            <div class="advanced_link text-center">
              <div class="info_label"><span>Есть аккаунт?</span>
                <a :href="`/admin2/login/`" class="info_label accent-item">
                  Войти
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import validateMixin from './common';
import MaskedInput from 'vue-masked-input';
import {Timezones} from '../common/timezones';
import phoneInput from '@/components/common/PhoneInput'
import leftRegisterBar from "@/components/common/leftRegisterBar";
import {isMobile} from "@/common/osChecker";
import { relPath } from "../../vue.config";

export default {
  name: 'StepOne',
  components: {
    MaskedInput,
    phoneInput,
    leftRegisterBar
  },
  mixins: [validateMixin],
  props: {
    context: {required: true}
  },

  data() {
    return {
      registrationTypes: [
        {
          name: 'Юридическое лицо'
        },
        {
          name: 'Физическое лицо'
        }
      ],
      rules: {
        registrationType: [
          {
            required: true,
            message: 'Выберите Тип регистрации',
            trigger: 'blur'
          }
        ],
        companyName: [
          {
            required: true,
            message: 'Необходимо заполнить поле Название компании',
            trigger: 'blur'
          },
          {
            min: 0,
            max: 120,
            message: 'Длина названия не может превыщать 120 символов',
            trigger: 'blur'
          }
        ],
        country: [
            {
                required: true,
                message: 'Необходимо заполнить поле Страна',
                trigger: 'change'
            }
        ],
        timezone: [
            {
                required: true,
                message: 'Необходимо заполнить поле Таймзона',
                trigger: 'change'
            }
        ],
        mail: [
          {
            required: true,
            message: 'Необходимо заполнить поле Электронная почта',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Введите валидный адрес електронной почты',
            trigger: 'blur'
          },
          {validator: this.validateEmail, trigger: 'blur'}
        ],
          phone: [
              {
                required: true,
                message: 'Необходимо заполнить поле Контактный телефон',
                trigger: 'blur'
            },
              {validator: this.validatePhone, trigger: 'blur'}
          ]
      },
        isValidPhone: '',
        timezones: [],
        countries: [
            {label: 'Россия', value: 'RU'},
            {label: 'Украина', value: 'UA'},
            {label: 'Беларусь', value: 'BY'}
        ],
      base_url: relPath
    };
  },
  computed: {
    isMobileDevice() {
      return isMobile() || false;
    }
  },
  methods: {
      phoneValChanged(val) {
          this.context.phone = val.number;
          if(val.isValid) {
              this.validatePhone(null, val.number);
          }
      },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return false;
        this.$emit('onSubmit');
      });
    }
  },
  beforeMount() {
      this.timezones = Timezones;
  }
};
</script>

<style lang="sass">
  @import '@/assets/_promo-auth'
</style>

